import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { api } from '@/lib/api';
import { Star, Crown, Trophy } from '@phosphor-icons/react';

const StarsWall = () => {
  const [data, setData] = useState({ year: new Date().getUTCFullYear(), wall: [] });

  useEffect(() => {
    api.get('/stars/wall').then(({ data }) => setData(data));
  }, []);

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-8 py-12 pb-24">
      <div className="text-center mb-10">
        <div className="text-[10px] uppercase tracking-[0.4em] text-bx-gold flex items-center justify-center gap-1.5">
          <Trophy size={12} weight="fill" /> wall of stars · {data.year}
        </div>
        <h1 className="font-display text-5xl sm:text-6xl font-black tracking-tighter mt-3">
          The <span className="shimmer-text">Star Wall</span>
        </h1>
        <p className="text-white/65 mt-3 max-w-lg mx-auto">
          People who placed a 🌟 Memorial Star on a grave this year. Their light stays here forever.
        </p>
      </div>

      {data.wall.length === 0 ? (
        <div className="glass rounded-2xl p-10 text-center text-white/65" data-testid="stars-empty">
          <div className="text-5xl mb-3">🌟</div>
          <div className="text-sm">No stars placed yet this year. Be the first.</div>
        </div>
      ) : (
        <div className="grad-border p-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {data.wall.map((row, i) => (
              <motion.div
                key={row.username}
                initial={{ y: 8, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ delay: i * 0.04 }}
                className="glass-hi rounded-xl p-4 flex items-center gap-3"
                data-testid={`star-row-${row.username}`}
              >
                <div className="relative h-12 w-12 rounded-full bg-gradient-to-br from-bx-gold to-bx-magenta grid place-items-center text-black text-xl font-black">
                  {row.username[0]?.toUpperCase() || '★'}
                  {row.founder_number && row.founder_number <= 100 && (
                    <Crown size={12} weight="fill" className="absolute -top-1 -right-1 text-bx-gold" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-white">@{row.username}</div>
                  <div className="text-[10px] uppercase tracking-widest text-white/60">
                    {row.memorials_count} grave{row.memorials_count === 1 ? '' : 's'} honored
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-display text-xl font-black text-bx-gold flex items-center gap-1">
                    <Star size={14} weight="fill" /> {row.stars}
                  </div>
                  <div className="text-[10px] uppercase tracking-widest text-white/60">
                    ${row.total_usd.toFixed(0)}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StarsWall;
